import { isAuthenticated } from '../../../../domain'
import { getCoreAssetType } from '../../../../state/configuration'
import { CheckoutConfigContext } from './types'

export const always = () => true

export const isNotAuthenticated = ({ principal, policyholder }: CheckoutConfigContext) =>
  !isAuthenticated(policyholder, principal)

export const hasFinalMile = ({ product }: CheckoutConfigContext) =>
  Boolean(product.finalMile?.form?.length ?? false)

export const hasAddons = ({ product }: CheckoutConfigContext) => {
  const coreAssetType = getCoreAssetType(product)
  return coreAssetType.covers.optional?.some((it) => !it.form) ?? false
}
